import BaseService from '@peoplenet/vi-components-ui/src/middleware/BaseService';
import customerService from '../customer/CustomerService';

class ResetPasswordService extends BaseService {
  prefix = '/customers/setting/install/password';

  async search() {
    let userInfo = await super.search();

    if (!userInfo.data.userName) {
      const companyName = await customerService.getCompanyName();
      userInfo = await super.search({ companyName });
    }

    return userInfo;
  }
}

export default new ResetPasswordService();
